module.exports = __webpack_public_path__ + "media/components/assets/img/avatar-woman-c27d80ec4fe6e86089ae4b19c8d417b6.png";